import { ListItem, QueryList, Size } from 'construct-ui'
import { m } from 'mithril';
import codeMasterModel from '../../models/common/code-master.model';
import log from '../../utils/logger';
import '../../utils/extensions';

/**
 * @deprecated
 */
export default function searchDialogSingleContentComponent() {
  let _attrs;
  let selectedListFrom = [];
  let addedList = [];
  let searchResult = [];

  let _onOk = () => {
    _attrs.onOk(addedList);
    _attrs.onCancel();
  }

  let renderItemFrom = (item) => {
    return m(ListItem, {
      label: item.name,
      selected: selectedListFrom.codeExists(item.code)
    })
  }

  let itemPredicate = (query, item) => {
    var xxx = item.name.toLowerCase().includes(query.toLowerCase());
    return xxx;
  }

  let handleSelectFrom = (item) => {
    if (item.code == "") {
      selectedListFrom.splice(0, selectedListFrom.length);
    } else if (selectedListFrom.codeExists(item.code)) {
      selectedListFrom.splice(selectedListFrom.indexOf(item), 1)
    } else {
      selectedListFrom = [];
      selectedListFrom.push(item);
    }
    _addToList();
  }

  let searchCodeMaster = (val) => {
    log.p(`searchCodeMaster = ${val}`);
    codeMasterModel.search(
      (result) => {
        searchResult = result;
      },
      (error) => {
        return [];
      },
      { category: _attrs.category, value: val, countryCode: _attrs.countryCode }
    );
  }

  let _search = () => {
    var val = document.getElementById('txtSearch').value;
    searchCodeMaster(val);
  }

  let _addToList = () => {
    addedList = [];
    addedList.addList(selectedListFrom); // INSERT 
  }

  return {
    oninit: ({ attrs }) => {
      _attrs = attrs;
      addedList = _attrs.values;
    },
    view: ({ attrs }) => {
      _attrs = attrs;

      return m('div',
        // Search Row
        m('div', { 'class': 'row g-3 align-items-center justify-content-md-center mb-3 mt-3' },
          [m('div', { 'class': 'col-auto' },
            m('label.col-form-label.text-end', "Search")
          ),
          m('div', { 'class': 'col-md-7' },
            m('input.form-control', {
              id: 'txtSearch'
            })
          ),
          m('div', { 'class': 'col-auto' },
            m('button.btn.btn-primary.px-4', { onclick: _search }, "Search")
          )
          ]
        ),
        m('div', { 'class': 'row g-3 align-items-center justify-content-md-center' },
          m('p.text-muted.text-center', _attrs.note)
        ),
        m('div', { "class": "p-3" },
          m('div', { 'class': 'row justify-content-md-center ' },
            [
              m('div', { 'class': 'col' },
                m('p', { 'class': 'mb-1' }, m('i', { 'class': 'bi-arrow-down-short' }, "Choose"))
              ),
            ]
          ),
          // Boxes
          m('div', { 'class': 'row justify-content-md-center mb-3' },
            [
              m('div', { 'class': 'col card' },
                m('div', { 'class': 'card-body' },

                  m(QueryList, {
                    disableArrowKeys: false,
                    checkmark: true,
                    items: searchResult,
                    itemPredicate: itemPredicate,
                    itemRender: renderItemFrom,
                    onSelect: handleSelectFrom,
                    listAttrs: {
                      style: 'height:300px; width:300px',
                      size: Size.DEFAULT
                    }
                  })
                )
              ),
            ]
          ),
        ),
        m("p", ""),
        m('.col-md-12 .gap-2 .d-flex .justify-content-center',
          m("button.btn.btn-secondary[type='button']", {
            onclick: _attrs.onCancel
          }, 'Cancel'
          ),
          m("button", {
            type: "button",
            class: "btn btn-primary ",
            onclick: _onOk
          }, 'Ok')
        )
      );
    }
  };
}
